import { create } from 'zustand';
import { Platform } from '../services/platformService';

// Interface for the structure of a job to be displayed on the Jobs page
export interface DisplayedJob {
  id: number; // From API response
  frontendJobName: string; // User-defined name or 'Untitled Job'
  jobTypeId: number; // ID of the selected job type
  jobTypeName: string; // Name of the selected job type
  sourcePlatformId: number; // ID of the source platform
  sourcePlatformName: string; // Name of the source platform
  targetPlatformId: number; // ID of the target platform
  targetPlatformName: string; // Name of the target platform
  status: string; // From API response
  createdAt: string; // From API response, formatted for display
  updatedAt?: string; // Optional updated timestamp
}

interface PlatformState {
  platforms: Platform[];
  selectedSourcePlatform: Platform | null;
  selectedTargetPlatform: Platform | null;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  setPlatforms: (platforms: Platform[]) => void;
  setSourcePlatform: (platform: Platform | null) => void;
  setTargetPlatform: (platform: Platform | null) => void;
  displayedJobs: DisplayedJob[];
  addDisplayedJob: (job: DisplayedJob) => void;
  activeView: string; // e.g., 'platformSelector', 'jobs', 'createPlatform'
  setActiveView: (viewName: string) => void;
  editingJobTypeId: number | null;
  setEditingJobTypeId: (id: number | null) => void;
}

export const usePlatformStore = create<PlatformState>((set) => ({
  platforms: [],
  selectedSourcePlatform: null,
  selectedTargetPlatform: null,
  isLoading: false,
  setIsLoading: (loading) => set({ isLoading: loading }),
  setPlatforms: (platforms) => set({ platforms }),
  setSourcePlatform: (platform) => set({ selectedSourcePlatform: platform }),
  setTargetPlatform: (platform) => set({ selectedTargetPlatform: platform }),
  displayedJobs: [],
  addDisplayedJob: (job) => set((state) => ({ displayedJobs: [...state.displayedJobs, job] })),
  activeView: 'PlatformDashboard', // Default view
  setActiveView: (viewName) => set({ activeView: viewName }),
  editingJobTypeId: null,
  setEditingJobTypeId: (id) => set({ editingJobTypeId: id }),
}));
